"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorValidation = void 0;
var validatorCons = require("../model/common");
var ErrorValidation = (function () {
    function ErrorValidation() {
    }
    ErrorValidation.prototype.validateSdkConfig = function (data) {
        if (data && data.encrypt) {
            var errorMessage = '';
            if (data.encrypt.type) {
                if (!validatorCons.ENCRYPT_TYPE.includes(data.encrypt.type)) {
                    errorMessage = validatorCons.ENCRYPT_SUPPORTED_MESSAGE;
                }
            }
            else if (data.encrypt.mode) {
                if (!validatorCons.ENCRYPT_MODE.includes(data.encrypt.mode)) {
                    errorMessage = validatorCons.ENCRYPT_SUPPORTED_MESSAGE;
                }
            }
            else if (data.encrypt.padding) {
                if (!validatorCons.ENCRYPT_PADDING.includes(data.encrypt.padding)) {
                    errorMessage = validatorCons.ENCRYPT_SUPPORTED_MESSAGE;
                }
            }
            else if (data.encrypt.iv) {
                if (typeof data.encrypt.iv !== 'string') {
                    errorMessage = validatorCons.ENCRYPT_SUPPORTED_MESSAGE;
                }
            }
            else if (data.encrypt.key) {
                if (typeof data.encrypt.key !== 'string') {
                    errorMessage = validatorCons.ENCRYPT_SUPPORTED_MESSAGE;
                }
            }
            if (errorMessage && errorMessage.length > 0) {
                throw Error(errorMessage);
            }
        }
    };
    ErrorValidation.prototype.getDomParsingError = function () {
        var responseData = {
            html: '',
            errors: [
                {
                    statusCode: validatorCons.TEMPLATE_PARSING_ISSUE,
                    messages: [validatorCons.TEMPLATE_PARSING_ERROR_MESSAGE],
                },
            ],
        };
        return responseData;
    };
    return ErrorValidation;
}());
exports.ErrorValidation = ErrorValidation;
//# sourceMappingURL=error_validation.js.map